import {Component, ElementRef, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import { AppStateService } from 'services/app/app-state.service';
import {Router} from '@angular/router';
import {KundeService} from '../../../../services/kunden/kunde.service';
import {MandantenService} from '../../../../services/mandanten/mandanten.service';
import {RegistrierungService} from '../../../../services/registrierung/registrierung.service';
import {Platform} from '@angular/cdk/platform';
import {FlexLinkService} from '../../../../services/navigation/flexLink.service';
import {StateService} from '../../../../services/app/state.service';
import {MatDialogRef} from '@angular/material/dialog';
import {DialogVerwaltungsService} from '../../dialog/services/dialogVerwaltungs.service';
import {PasswortVergessenComponent} from '../passwortVergessen/passwortVergessen/passwortVergessen.component';
import {environment} from '../../../../environments/environment';
import {Observable, of} from 'rxjs';
import {ConfirmDialogComponent} from '../../dialog/confirm-dialog/confirm-dialog.components';
import {BestellungService} from '../../../../services/bestellung/bestellung.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  public hide: boolean = true
  public registerButton
  public mandant
  public methode
  public login_form: UntypedFormGroup
  public detectedPlattform: string
  public error = false
  @ViewChild('login') login: ElementRef;
  @ViewChild('password') password: ElementRef;
  @ViewChild('') passwortVergessen: PasswortVergessenComponent
  @Output() loginEvent = new EventEmitter()
  @Output() buttonClickedEvent = new EventEmitter<void>();

  constructor(
    private app_state_service: AppStateService,
    private router: Router,
    public platform: Platform,
    public flexLink: FlexLinkService,
    private kunde_service: KundeService,
    private mandant_service: MandantenService,
    public registrationService: RegistrierungService,
    public stateService: StateService,
    private dialogService: DialogVerwaltungsService,
    private bestellungenService: BestellungService,
  ) {
    this.app_state_service.set_page_name('Anmelden');
    this.app_state_service.set_page_navigation('profils');
  }

  async ngOnInit() {
    if (this.platform.ANDROID) {
      this.detectedPlattform = 'ANDROID'
    }
    else if (this.platform.IOS) {
      this.detectedPlattform = 'IOS'
    }
    else {
      this.detectedPlattform = 'WEB'
    }
    this.mandant_service.mandant_get().subscribe(async (mandant) => {
      this.mandant = mandant
      if (this.mandant.darstellungRegistrierung != 3) {
        let vertrag = Object.keys(mandant.registrierFormen)
        if (vertrag.length > 0) {
          this.methode = mandant.registrierFormen[vertrag[0]].registrierArt
        }
      }
      this.registerButton = this.stateService.registerButton(mandant)
    })
    this.login_form = new UntypedFormGroup({
      'login': new UntypedFormControl('', Validators.required),
      'password': new UntypedFormControl('', Validators.required)
    });
  }

  buttonClicked() {
    this.buttonClickedEvent.emit();
  }

  public on_change_login(): void {
    this.login_form.get('login').setValue(this.login.nativeElement.value)
  }

  public on_change_pw(): void {
    this.login_form.get('password').setValue(this.password.nativeElement.value)
  }

  onSubmit(): void {
    let confirm: Observable<boolean> = of(true);
    if (environment.type == 'mobil' && this.bestellungenService._bestellungen_meta.anzahl > 0) {
      confirm = this.dialogService.optionsDialog(
        'Achtung',
        ConfirmDialogComponent,
        {'Nein': ['var(--bad)', false], 'Ja': ['var(--good)', true]},
        {message: "Sie haben noch offene Bestellvorgänge. Möchten Sie trotzdem fortfahren?"}
      ).afterClosed();
    }
    confirm.subscribe((result) => {
      if (result) {
        this.bestellungenService.bestellungen_leeren()
        const credentials = this.login_form.value;
        this.loginEvent.emit(this.kunde_service.kunde_login({
          user: credentials.login,
          password: credentials.password
        }))
      }
    })
  }

  public link_pw_forget() {
    if (this.detectedPlattform == 'WEB'){
      const dialogRef: MatDialogRef<any> = this.dialogService.optionsDialog(
        'Passwort vergessen',
        PasswortVergessenComponent,
        {
          'Abbrechen': ['var(--bad)', false],
          'Kundennummer überprüfen':  ['var(--good)', true]
        },
        {})
      dialogRef.afterClosed().subscribe(result => {
        if (result){
          result.instance.on_submit(result.instance.passwort_vergessen.value.kundennummer)
        }
      })
    }
    else {
      this.router.navigateByUrl('passwort-vergessen')
    }
  }

  public show_pw(element) {
    if (element.type === 'password') {
      element.type = 'text';
    } else {
      element.type = 'password';
    }
  }

}
